// Global click interceptor that routes same-origin <a href> clicks through
// Inertia, so Vuetify components using `:href` get SPA navigation for free
// without having to wrap every button in <Link>. Skips:
//   - external links (http://, mailto:, tel:)
//   - modifier-key clicks (cmd/ctrl/shift/alt → open in new tab)
//   - target="_blank"
//   - anchors with [data-inertia-skip]
//   - events whose default was already prevented (Inertia's <Link> ran first)

import { router } from '@inertiajs/vue3'

export default {
  install() {
    if (typeof document === 'undefined') return

    document.addEventListener('click', (event) => {
      if (event.defaultPrevented) return
      if (event.button !== 0) return
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return

      const anchor = event.target instanceof Element ? event.target.closest('a[href]') : null
      if (!anchor) return
      if (anchor.target === '_blank') return
      if (anchor.dataset.inertiaSkip != null) return

      const href = anchor.getAttribute('href')
      if (!href) return
      if (/^(https?:|mailto:|tel:|javascript:)/.test(href)) return
      if (href.startsWith('#')) return

      event.preventDefault()
      router.visit(href)
    })
  },
}
